import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "../../lib/seo";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-gray-100 bg-white/85 backdrop-blur-xl">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" data-testid="nav-logo-link" className="flex h-20 w-56 items-center overflow-hidden">
          <img src={LOGO_URL} alt="VeraScreen Solutions" className="h-16 w-auto origin-left scale-150" />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-semibold tracking-wide transition-colors duration-200 ${
                  isActive ? "text-[#0E7B6B]" : "text-[#333333] hover:text-[#1A3A6B]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/request-a-screening" data-testid="nav-request-screening-btn" className="btn-gold !px-5 !py-2.5">
            Request a Screening
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-menu-btn"
          className="text-[#1A3A6B] lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-gray-100 bg-white px-5 pb-6 pt-3 lg:hidden">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="block py-3 text-base font-semibold text-[#1A3A6B]"
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/request-a-screening" data-testid="nav-mobile-request-btn" className="btn-gold mt-3 w-full">
            Request a Screening
          </Link>
        </div>
      )}
    </header>
  );
};
